import { normalizeSummaryConfig } from '../features/summary/normalizeSummaryConfig';
import { normalizeSummaryRow } from '../features/summary/renderSummary';
import { SummaryRowBuilder } from './SummaryRowBuilder';

export class SummaryBuilder {
    constructor() {
        this._summary = {
            scope: 'filtered',
            className: '',
            variant: 'default',
            emptyText: '',
            gap: '16px',
            valueColumns: 0,
            rows: []
        };
    }

    withScope(scope) {
        this._summary.scope = scope;
        return this;
    }

    withClass(className) {
        this._summary.className = className;
        return this;
    }

    withVariant(variant) {
        this._summary.variant = variant;
        return this;
    }

    /**
     * Convenience alias for `.withVariant('invoice')`.
     * @returns {this}
     */
    withInvoiceTheme() {
        return this.withVariant('invoice');
    }

    /**
     * Convenience alias for `.withVariant('default')`.
     * @returns {this}
     */
    withDefaultVariant() {
        return this.withVariant('default');
    }

    withEmptyText(text) {
        this._summary.emptyText = text;
        return this;
    }

    withGap(gap) {
        this._summary.gap = gap;
        return this;
    }

    withoutGap(enabled = true) {
        this._summary.gap = enabled ? 0 : '16px';
        return this;
    }

    withValueColumns(count) {
        this._summary.valueColumns = count;
        return this;
    }

    withRow(labelOrBuilderFn, maybeBuilderFn = null) {
        const builder = new SummaryRowBuilder();

        if (typeof labelOrBuilderFn === 'string') {
            builder.withLabel(labelOrBuilderFn);
            if (typeof maybeBuilderFn === 'function') {
                maybeBuilderFn(builder);
            }
        } else if (typeof labelOrBuilderFn === 'function') {
            labelOrBuilderFn(builder);
        } else if (labelOrBuilderFn) {
            this._summary.rows.push(normalizeSummaryRow(labelOrBuilderFn));
            return this;
        }

        this._summary.rows.push(builder.build());
        return this;
    }

    build() {
        return normalizeSummaryConfig(this._summary);
    }
}
